import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from 'src/app/app-routes';

export const validateAccessGuard: CanActivateFn = (route, state) => {
	const location = inject(Location);
	const router = inject(Router);

	if (state.url === location.path(false)) {
		return router.createUrlTree([AppRoutes.HOME]);
	}
	return true;
};
